import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal, Typography } from 'antd';
import { StyleSheet, css } from 'aphrodite';

// CSS styles
const sx = StyleSheet.create({
  modalContainer: {
    minWidth: '583px',
  },
  button: {
    padding: '8px 40px',
    fontSize: '16px',
  },
});

const { Title } = Typography;
const DeleteConfirmationModal = ({
  onCloseModal, // use this to close the model and refresh the states.
  closeDeleteModal,
  visible,
}) => {
  const [form] = Form.useForm();

  const onCancel = () => {
    onCloseModal();
  };

  const onConfirm = () => {
    closeDeleteModal();
    onCloseModal();
  };

  return (
    <Modal
      className={css(sx.modalContainer)}
      footer={[
        <Button key="cancel" onClick={onCancel} className={css(sx.button)}>
          No
        </Button>,
        <Button key="submit" type="primary" onClick={onConfirm} className={css(sx.button)}>
          Yes
        </Button>,
      ]}
      getContainer={false}
      okText="Save"
      onOk={onConfirm}
      onCancel={onCancel}
      open={visible}
    >
      <Title className="modelHeaderText" level={3}>
        Delete
      </Title>
      <Form name="modify-form-ref" form={form} layout="vertical">
        <div className={css(sx.flexContainer)}>
          <div className={css(sx.inputBox)}>
            <p className={css(sx.label)}>Are you sure you want to delete this email?</p>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  closeDeleteModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  visible: PropTypes.bool,
};

export default DeleteConfirmationModal;
